import React from 'react';
import { useSelector } from 'react-redux';
import { BackdropCircular, Breadcrumb } from 'components';
import RecentQuotesTable from '../QuoteWorkspace/PatientDetails/RecentQuotesTable';


const QuoteProgression = () => {
  const {
    quoteProductsLoading,
    loadingCustomerAmastyQuotes,
  } = useSelector((state: IReduxState) => state.quote);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Quote Progression' }
          ]}
        />
      </div>
      <div className="px-10">
        <RecentQuotesTable
          searchFields={[
            {field: 'increment_id', name: 'Quote ID'},
            {field: 'customer_name', name: 'Customer Name'},
            {field: 'customer_email', name: 'Customer Email'},
            {field: 'created_by_doctor', name: 'Created By'},
          ]}
        />
      </div>
      <BackdropCircular loading={loadingCustomerAmastyQuotes || quoteProductsLoading} />
    </div>
  );
};

export default QuoteProgression;
